import { useRef, useState } from "react";
import SectionHeading from "./SectionHeading";
import { archiveItems, trendTags } from "@/mocks/home";

export default function ArchiveSection() {
  const [toast, setToast] = useState("");
  const timer = useRef<number | null>(null);

  const handlePick = (title: string) => {
    setToast(`「${title}」的下载入口为演示效果，暂未接入真实下载`);
    if (timer.current) window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setToast(""), 2600);
  };

  return (
    <section id="archive" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto px-4 md:px-6">
        <SectionHeading
          id="archive"
          kicker="最新归档"
          title="最新整理的黑料汇总归档"
          desc="按更新时间排序的归档列表，每条都标注了所属主题、格式与体积，右侧下载入口随时可取，无需再一页页翻找。"
          actionLabel="归档时间线"
          actionHref="#rank"
          actionIcon="ri-history-line"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <ul className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-100">
              {archiveItems.map((item) => (
                <li
                  key={item.id}
                  className="flex flex-col gap-4 p-4 transition-colors hover:bg-background-200/50 sm:flex-row sm:items-center sm:justify-between md:p-5"
                >
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="rounded-full bg-primary-100 px-2.5 py-0.5 font-label text-[11px] font-medium text-primary-700">
                        {item.category}
                      </span>
                      {item.hot && (
                        <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2.5 py-0.5 font-label text-[11px] font-medium text-accent-800">
                          <i className="ri-fire-line w-3 h-3 flex items-center justify-center"></i>
                          高热
                        </span>
                      )}
                    </div>
                    <h3 className="mt-2 truncate font-heading text-base font-semibold text-foreground-950">
                      <a href="#archive" className="cursor-pointer hover:text-primary-700">
                        {item.title}
                      </a>
                    </h3>
                    <p className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 font-label text-xs text-foreground-500">
                      <span className="flex items-center gap-1">
                        <i className="ri-calendar-line w-3.5 h-3.5 flex items-center justify-center"></i>
                        {item.date}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-file-text-line w-3.5 h-3.5 flex items-center justify-center"></i>
                        {item.size}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line w-3.5 h-3.5 flex items-center justify-center"></i>
                        {item.views} 次查阅
                      </span>
                    </p>
                  </div>
                  <button
                    type="button"
                    onClick={() => handlePick(item.title)}
                    className="inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                  >
                    <i className="ri-download-2-line w-4 h-4 flex items-center justify-center"></i>
                    下载入口
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <aside className="space-y-6 lg:col-span-4">
            <div className="rounded-lg border border-background-200 bg-secondary-950 p-5">
              <h3 className="font-heading text-lg font-bold text-background-50">快捷入口</h3>
              <p className="mt-2 text-xs leading-relaxed text-background-100/70">
                一次拿不完整？可以先按主题订阅，更新后会提醒你回来取。
              </p>
              <div className="mt-4 space-y-2.5">
                <a
                  href="#subscribe"
                  className="flex items-center justify-between whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 font-label text-sm font-medium text-secondary-950 transition-colors hover:bg-accent-400"
                >
                  订阅更新提醒
                  <i className="ri-notification-3-line w-4 h-4 flex items-center justify-center"></i>
                </a>
                <button
                  type="button"
                  onClick={() => handlePick("全部归档合集包")}
                  className="flex w-full items-center justify-between whitespace-nowrap rounded-md border border-background-100/25 px-4 py-2.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
                >
                  打包下载全部
                  <i className="ri-archive-drawer-line w-4 h-4 flex items-center justify-center"></i>
                </button>
              </div>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-100 p-5">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <i className="ri-price-tag-3-line w-4 h-4 flex items-center justify-center text-primary-600"></i>
                常用整理标签
              </h3>
              <div className="mt-4 flex flex-wrap gap-2">
                {trendTags.map((tag) => (
                  <a
                    key={tag}
                    href="#collections"
                    className="whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-3 py-1.5 font-label text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
                  >
                    {tag}
                  </a>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </div>

      {toast && (
        <div className="fixed bottom-6 left-1/2 z-50 -translate-x-1/2 rounded-md bg-foreground-950 px-4 py-2.5 font-label text-xs text-background-100">
          {toast}
        </div>
      )}
    </section>
  );
}